<template>
  <div class="step-line row">
    <div class="col-xs-4 col-sm-3 col-md-2 partnerImage">
      <p>
        <img :src="partnerImageUrl" alt="" aria-hidden="true" />
      </p>
    </div>
    <div class="col-xs-8 col-sm-9 col-md-10 partnership">
      <p>
        <a :href="trackingUrl">{{ $t(`tracking.partnerLine.link`) }}</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    partnerInfos: {
      type: Object,
      required: true,
    },
  },
  computed: {
    partnerImageUrl() {
      const code = this.partnerInfos?.CodePartenaire;
      if (!code) return "";
      return `https://www.mondialrelay.fr/images/partenaires/${code}.jpg`;
    },

    trackingUrl() {
      return this.partnerInfos?.UrlSuiviColisPartenaire || "#";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./PartnerLine.scss";
</style>
